<template>
  <!--  查看违规内容  -->
  <van-dialog v-model="visible" title="串店信息" class="title" @confirm="onOk">
    <div style="margin: 10px auto">
      <div class="header row" style="font-size: 15px;color: black;">
        <div class="col title-shop">店铺</div>
        <div class="col title-clerk">店员</div>
        <div class="col title-state">状态</div>
      </div>
      <div class="padding-xs">
        <div class="row" v-for="(item,index) in otherShop" :key="index">
          <div class="col title-shop">{{item.shop}}</div>
          <div class="col title-clerk">{{item.clerk}}</div>
          <div class="col title-state" v-if="item.isDisabled==false">上架</div>
          <div class="col title-state" v-else-if="item.isDisabled==true">下架</div>
          <div class="col title-state" v-else> </div>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import Vue from 'vue';
import {Dialog} from 'vant';


Vue.use(Dialog)
/* 主要是用来显示二维码，如果想带logo就往headImg里面传值 */
export default {
  name: 'other-shop-dialog',
  components: {
  },
  props: {
    otherShop: {
      type: Array
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  model: {
  },
  data(){
    return{
      visible: this.value,
    }
  },
  mounted () {

  },
  watch: {
    value (val) {
      this.visible = val
    }
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  },
  methods:{
    onOk(){
      this.$emit("changeShowOtherShop", false)
    },

  }
}
</script>

<style lang="less" scoped>
.header{
  background-color: #f8f8f9;
}
.row{
  display: flex;
  justify-content: space-around;
  padding: 5px;
}
.title-shop{
  width: 40%;
  text-align: center;
}
.title-clerk{
  width: 40%;
  text-align: center;
}
.title-state{
  width: 20%;
  margin-right: 20px;
  text-align: center;
}
</style>

